module.exports = __webpack_public_path__ + "static/card-d4a630c5f51f5bc423fbb96940a87781.png";